export default {
  userLoaded(state) {
    return state.userLoaded;
  },
  companyLoaded(state) {
    return state.company.companyLoaded;
  },
  companyUsersLoaded(state) {
    return state.company.companyUsersLoaded;
  },
  usersName(state) {
    return state.usersName;
  },
  emailAddress(state) {
    return state.emailAddress;
  },
  userPoints(state) {
    const user = state.users.find((usr) => usr.userId == state.userId);
    return user ? user.points : 0;
  },
  profileInitials(state) {
    if (state.usersName.firstName != null) {
      return (
        state.usersName.firstName.charAt(0) + state.usersName.lastName.charAt(0)
      );
    } else {
      return "P";
    }
  },
  profilePicture(state) {
    return state.profilePicture;
  },
  userId(state) {
    return state.userId;
  },
  roleId(state) {
    return state.roleId;
  },
  userType(state) {
    return state.userType;
  },
  companies(state) {
    return state.companies;
  },
  companyDetails(state) {
    return state.company;
  },
  companyId(state) {
    return state.company.companyId;
  },
  companyName(state) {
    return state.company.name;
  },
  companyUsers(state) {
    return state.users;
  },
  companyLocations(state) {
    return state.company.locations;
  },
  userDepartments(state) {
    return state.departments;
  },
  companyDepartments(state) {
    return state.company.departments;
  },
  companyFeatures(state) {
    return state.company.features;
  },
  companyRecruitment(state) {
    return state.company.recruitment;
  },
  // Whether this company's onboarding expects a capability statement. Off
  // unless the company has said otherwise, so a company that has never heard
  // of one never sees the tab or the checklist row.
  capabilityStatementRequired(state) {
    return state.company.recruitment.capabilityStatementRequired === true;
  },
  companyRecruitmentIndustries(state) {
    return state.company.recruitment.industries;
  },
  companyType(state) {
    return state.company.companyType;
  },
  companyTitle(state) {
    return state.companyTitle;
  },
  allowAddUsers(state) {
    return state.company.allowAddUsers;
  },
  companyDomain(state) {
    return state.company.companyDomain;
  },
  companyCountryCode(state) {
    return state.company.countryCode;
  },
  onFreeTrial(state) {
    return state.onFreeTrial;
  },
  selectedCulture(state) {
    return state.selectedCulture;
  },
  termsAccepted(state) {
    return state.termsAccepted.accepted;
  },
  registrationComplete(state) {
    return state.company.registrationComplete;
  },
  sideMenuLock(state) {
    return state.sideMenuLock;
  },
  showBanner(state) {
    return state.showBanner;
  },
  jobPreferences(state) {
    return state.jobPreferences;
  },
  theme(state) {
    return state.theme;
  },
};
